import camelize from 'camelize';
import qs from 'query-string';


export const fetchVimeoData = id => {
  const apiUrl = 'https://vimeo.com/api/v2/video';
  return fetch(`${apiUrl}/${id}.json`)
    .then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    })
    .then(response => response.json())
    .then(data => camelize(data))
    .catch(err => {
      console.log(err);
    });
};

export const fetchVimeoOembedData = (url, maxwidth = 1920) => {
  const apiUrl = 'https://vimeo.com/api/oembed.json';
  const queryString = qs.stringify({ url, maxwidth });
  return fetch(`${apiUrl}?${queryString}`)
    .then(response => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    })
    .then(response => response.json())
    .then(data => camelize(data))
    .catch(err => {
      console.log(err);
    });
};



// WEBPACK FOOTER //
// ./src/utils/vimeo.js